import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class PlayerTable extends PureComponent<any, any> {
  rows() {
    let players = this.props.players.slice();
    if (this.props.size) {
      players = players.slice(0, this.props.size);
    }
    return players.map((player, i) => {
      return (
        <tr
          key={i}
          className={this.trClassName(player.tier, player.position, this.props.disableColor)}
          onClick={() => this.onClick(player)}
        >
          {this.columns(player)}
        </tr>
      );
    });
  }

  onClick(player) {
    if (this.props.onClick) {
      return this.props.onClick(player);
    }
  }

  trClassName(tier, position, disable) {
    if (disable) {
      return 'pointer';
    }
    if (position == 'QB') {
      tier = (tier * 2) - 1;
    }
    if (tier == 1) {
      return position + '400 pointer';
    } else if (tier == 2 || tier == 3) {
      return position + '300 pointer';
    } else if (tier == 4 || tier <= 5) {
      return position + '200 pointer';
    } else if (tier == 6 || tier == 7) {
      return position + '100 pointer';
    } else {
      return position + '50 pointer';
    }
  }

  columns(player) {
    return this.props.fields.map((f, i) => {
      if (f === 'tier') {
        return <td key={i}>T{player[f]}</td>;
      } else {
        return <td key={i}>{player[f]}</td>;
      }
    });
  }

  render() {
    return (
      <table className="table table-condensed table-hover">
        <tbody>{this.rows()}</tbody>
      </table>
    );
  }

  static propTypes = {
    players: PropTypes.array.isRequired,
    fields: PropTypes.array.isRequired,
    onClick: PropTypes.func,
    size: PropTypes.number,
    disableColor: PropTypes.bool,
  };
}

export default PlayerTable;
